module.exports = __webpack_public_path__ + "img/23.1b6327de.jpg";